export default {
    methods: {
        generateProductSchema() {
            const route = this.$route;
            let schemaData = {
                "@context": "https://schema.org/",
                "@type": "Product",
                "name": this.$route.meta.metaInfo.title,
                "description": this.$route.meta.metaInfo.description,
                "brand": {
                    "@type": "Brand",
                    "name": "杉脉科技"
                },
                "manufacturer": {
                    "@type": "Organization",
                    "name": "上海杉脉科技发展有限公司"
                }
            };

            // 根据不同产品类型添加特定信息
            switch (route.name) {
                case 'entranceGuard':
                    schemaData = {
                        ...schemaData,
                        "category": "智能门禁系统",
                        "features": [
                            "人脸识别",
                            "指纹识别",
                            "IC卡识别",
                            "远程控制",
                            "访客管理"
                        ]
                    };
                    break;
                case 'displayCase':
                    schemaData = {
                        ...schemaData,
                        "category": "智能展柜系统",
                        "features": [
                            "智能锁具",
                            "远程管理",
                            "防盗报警",
                            "数据统计",
                            "展示管理"
                        ]
                    };
                    break;
                case 'softwarePlatform':
                    schemaData = {
                        ...schemaData,
                        "category": "智能管理软件",
                        "features": [
                            "多设备联动",
                            "数据分析",
                            "远程控制",
                            "权限管理",
                            "系统集成"
                        ]
                    };
                    break;
            }

            return schemaData;
        }
    },
    mounted() {
        // 动态添加结构化数据
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.innerHTML = JSON.stringify(this.generateProductSchema());
        document.head.appendChild(script);
    },
    beforeDestroy() {
        // 清理结构化数据
        const scripts = document.head.getElementsByTagName('script');
        for (let script of scripts) {
            if (script.type === 'application/ld+json') {
                document.head.removeChild(script);
            }
        }
    }
} 